import React from "react";

import { Row, Stack } from "react-bootstrap";

import classNames from "classnames";

import { PaymentStatuses, ResaleFragment, ResaleStatuses } from "@api/graphql";
import { BreadCrumbs } from "@components/form/BreadCrumbs";
import { formatDateStringLong } from "@util/index";

interface PaymentDetailsProps {
  resale: ResaleFragment;
}

export const PaymentTrackerDrawer = ({ resale }: PaymentDetailsProps) => {
  const breadCrumbSteps = [
    {
      name: "Reported",
      subtitle: formatDateStringLong(resale.reported_on ?? ""),
      showCurrentStepCompleted: true,
      predicate: (resale: ResaleFragment) =>
        resale.resale_status === ResaleStatuses.PROVISIONALLY_ELIGIBLE ||
        resale.resale_status === ResaleStatuses.PROVISIONALLY_INELIGIBLE,
    },
    {
      name: "Mandatory hold period",
      subtitle: resale?.opt_out_expiry ? `ends ${formatDateStringLong(resale.opt_out_expiry)}` : "",
      showCurrentStepCompleted: true,
      predicate: (resale: ResaleFragment) => {
        return (
          resale.resale_status === ResaleStatuses.OPTED_OUT ||
          resale.payment_status === PaymentStatuses.INVOICE_REQUEST_SENT ||
          resale.resale_status === ResaleStatuses.CONFIRMED_ELIGIBLE ||
          resale.resale_status === ResaleStatuses.RESEARCH_REQUIRED
        );
      },
    },
    {
      name: "Reseller invoiced",
      subtitle: "",
      showCurrentStepCompleted: true,
      predicate: (resale: ResaleFragment) => {
        return resale.payment_status === PaymentStatuses.AMP_INVOICE_REQUESTED;
      },
    },
    {
      name: "Reseller made payment",
      showCurrentStepCompleted: true,
      subtitle: "",
      predicate: (resale: ResaleFragment) =>
        resale.payment_status === PaymentStatuses.AMP_INVOICE_PAID ||
        resale.payment_status === PaymentStatuses.PAYMENT_REQUEST_SENT ||
        resale.payment_status === PaymentStatuses.ARTIST_PAYMENT_REQUESTED,
    },
    {
      name: "Paid",
      subtitle: "",
      showCurrentStepCompleted: true,
      predicate: (resale: ResaleFragment) => resale.payment_status === PaymentStatuses.ARTIST_PAID,
    },
  ];
  const determineCurrentStepIndex = (resale: ResaleFragment): number => {
    let currentStepIndex = -1;
    breadCrumbSteps.forEach((step, index) => {
      if (step.predicate(resale)) {
        currentStepIndex = index;
      }
    });
    return currentStepIndex;
  };
  return (
    <Stack gap={4} className={classNames("payment-details", "col-md-10")}>
      <Row>
        <span className="b3 monoBlack">Track this payment</span>
      </Row>
      <Row>
        <div className="payment-tracker">
          <BreadCrumbs
            steps={breadCrumbSteps}
            currentStepIndex={determineCurrentStepIndex(resale)}
            orientation="vertical"
          />
        </div>
      </Row>
    </Stack>
  );
};
